import { useSelector } from "react-redux";
import { useCompany } from "../Context/CompanyContext";

/**
 * Transitional bridge: delegates directly to useCompany() so any consumer
 * still calling useEffectiveProfile receives fresh, server-authoritative store
 * settings without reading or writing to localStorage.
 */
export function useEffectiveProfile() {
  const { company } = useCompany();
  const storeProfile = useSelector((state) => state.profiles?.profiles);
  return { ...(storeProfile || {}), ...(company || {}) };
}

export default useEffectiveProfile;
